import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {LoginPageRoutingModule} from './login-routing.module';
import {LoginPage} from './login.page';
import {TranslateModule} from '@ngx-translate/core';
import {LoginVeeamPage} from './login-veeam/login-veeam.page';
import {ComponentsModule} from '../components/components.module';
import {LoginLegacyPage} from './login-legacy/login-legacy.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoginPageRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    ComponentsModule,
  ],
  declarations: [
    LoginPage,
    LoginLegacyPage,
    LoginVeeamPage,
  ]
})
export class LoginModule {
}
